import { render, staticRenderFns } from "./CommentView.vue?vue&type=template&id=750d8553"
import script from "./CommentView.vue?vue&type=script&lang=js"
export * from "./CommentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports